import cx from "classnames";
import { Link, graphql, useStaticQuery } from "gatsby";
import React, { HTMLAttributes } from "react";

import * as classNames from "./WordMark.module.css";

import { SiteMetadataQueryResult } from "../graphql";
import Monogram from "./Monogram";

const WordMark: React.FC<HTMLAttributes<HTMLAnchorElement>> = ({
  className,
  ...props
}) => {
  const {
    site: { siteMetadata },
  } = useStaticQuery<SiteMetadataQueryResult>(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          author
          description
          language
          siteUrl
          title
        }
      }
    }
  `);
  return (
    <Link to="/" className={cx(classNames.root, className)} {...props}>
      <Monogram className={classNames.logo} border={true} />
      <span className={classNames.title}>{siteMetadata.title}</span>
    </Link>
  );
};

export default WordMark;
